{
	"asset": {
		"generator": "Khronos glTF Blender I/O v4.1.62",
		"version": "2.0"
	},
	"scene": 0,
	"scenes": [
		{
			"name": "Scene",
			"nodes": [0]
		}
	],
	"nodes": [
		{
			"mesh": 0,
			"name": "Icosphere",
			"rotation": [0.7210371494293213, 0, 0, 0.6928964257240295],
			"translation": [0, 1.0581220388412476, 0]
		}
	],
	"materials": [
		{
			"doubleSided": true,
			"name": "Material.003",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.4018639326095581, 0.5132083296775818, 0.5678637027740479, 1],
				"metallicFactor": 0.3149605989456177,
				"roughnessFactor": 0.38582709431648254
			}
		},
		{
			"doubleSided": true,
			"name": "Material.004",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.23454760015010834, 0.19314445555210114, 0.14950743317604065, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		}
	],
	"meshes": [
		{
			"name": "Icosphere",
			"primitives": [
				{
					"attributes": {
						"POSITION": 0,
						"NORMAL": 1,
						"TEXCOORD_0": 2
					},
					"indices": 3,
					"material": 0
				},
				{
					"attributes": {
						"POSITION": 4,
						"NORMAL": 5,
						"TEXCOORD_0": 6
					},
					"indices": 7,
					"material": 1
				}
			]
		}
	],
	"accessors": [
		{
			"bufferView": 0,
			"componentType": 5126,
			"count": 359,
			"max": [1.1033025979995728, 1.1638050079345703, 1.244782567024231],
			"min": [-1.4570996761322021, -1.1110413074493408, -1.1618808507919312],
			"type": "VEC3"
		},
		{
			"bufferView": 1,
			"componentType": 5126,
			"count": 359,
			"type": "VEC3"
		},
		{
			"bufferView": 2,
			"componentType": 5126,
			"count": 359,
			"type": "VEC2"
		},
		{
			"bufferView": 3,
			"componentType": 5123,
			"count": 531,
			"type": "SCALAR"
		},
		{
			"bufferView": 4,
			"componentType": 5126,
			"count": 169,
			"max": [0.9763026237487793, 1.0223212242126465, 0.9699355363845825],
			"min": [-0.951228678226471, -1, -1.0302280187606812],
			"type": "VEC3"
		},
		{
			"bufferView": 5,
			"componentType": 5126,
			"count": 169,
			"type": "VEC3"
		},
		{
			"bufferView": 6,
			"componentType": 5126,
			"count": 169,
			"type": "VEC2"
		},
		{
			"bufferView": 7,
			"componentType": 5123,
			"count": 177,
			"type": "SCALAR"
		}
	],
	"bufferViews": [
		{
			"buffer": 0,
			"byteLength": 4308,
			"byteOffset": 0,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 4308,
			"byteOffset": 4308,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2872,
			"byteOffset": 8616,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1062,
			"byteOffset": 11488,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 2028,
			"byteOffset": 12552,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2028,
			"byteOffset": 14580,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1352,
			"byteOffset": 16608,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 354,
			"byteOffset": 17960,
			"target": 34963
		}
	],
	"buffers": [
		{
			"byteLength": 18316,
			"uri": "raw_iron.bin"
		}
	]
}
